import { connect } from 'react-redux';

import { bookingsSelectors } from '~/api';

import { SuccessBookingMessage } from './SuccessBookingMessage';
import { envConfigSelectors } from '~/components';

export const mapStateToProps = (state) => ({
  email: bookingsSelectors.selectEmail(state),
  price: bookingsSelectors.selectTotalPrice(state),
  isBookingRemote: bookingsSelectors.selectBookingRemoteStatus(state),
  isBookingForSomeoneElse: bookingsSelectors.selectBookingIsForSomeoneElseAnswer(state),
  isGift: bookingsSelectors.selectIsGiftAnswer(state),
  SuccessBookingMessageParagraph: envConfigSelectors.bookingSuccessBookingMessageParagraph(
    bookingsSelectors.selectAppointmentTypeId(state),
  )(state),
  additionalDescription: envConfigSelectors.selectSuccessBookingMessageAdditionalDescription(
    bookingsSelectors.selectAppointmentTypeId(state),
  )(state),
});

export const SuccessBookingMessageContainer = connect(mapStateToProps)(SuccessBookingMessage);
